import { TFunction } from 'i18next'
import { logWarn } from '../../utils/logger'
import { Device } from '../../installation/forms'
import { sanitizeToLatin } from '../../installation/utils'

/** Get the display name of a device. */
export const getDeviceDefaultName = (name: Device['name'], category: Device['deviceCategory'], id: Device['deviceId'], t: TFunction): string => {
  if (category === 'EMC') return sanitizeToLatin(t('installation.productEditor.deviceTypes.emc'))

  if (name.trim()) return sanitizeToLatin(name.trim())

  if (category === 'Storage') return sanitizeToLatin(t('installation.types.storage'))

  if (category === 'ModbusTCP Evse' || category === 'EEBus Evse') {
    if (id) return sanitizeToLatin(t('installation.evseEditor.tileTitle', '', { id: id }))
    return sanitizeToLatin(t('installation.evseEditor.emptyTitle'))
  }

  if (category === 'Heatpump') {
    if (id) return sanitizeToLatin(t('installation.heatpumpEditor.tileTitle', '', { id: id }))
    return sanitizeToLatin(t('installation.heatpumpEditor.emptyTitle'))
  }

  if (category === 'Meter') {
    if (id) return sanitizeToLatin(t('installation.submeterEditor.tileTitle', '', { id: id }))
    return sanitizeToLatin(t('installation.submeterEditor.emptyTitle'))
  }

  if (category === 'HTC320H I/O' || category === 'Storage I/O' || category === 'MyPV I/O') {
    if (id) return sanitizeToLatin(t('installation.submeterEditor.ioTileTitle', '', { id: id }))
    return sanitizeToLatin(t('installation.submeterEditor.ioEmptyTitle'))
  }

  logWarn('No device type was found to display a default name.')

  return ''
}

export const getStorageName = (name: string | undefined, t: TFunction): string => {
  const nameToUse = name?.trim() || t('installation.types.storage')
  return sanitizeToLatin(nameToUse)
}
